var map = {
  "./da.json": [
    "4879",
    [
      58436
    ]
  ],
  "./fi.json": [
    "72181",
    [
      15350
    ]
  ],
  "./sv.json": [
    "24809",
    [
      28306
    ]
  ],
  "./ja.json": [
    "2241",
    [
      75738
    ]
  ],
  "./lt.json": [
    "46712",
    [
      79777
    ]
  ],
  "./sl.json": [
    "90999",
    [
      80636
    ]
  ],
  "./fr.json": [
    "27024",
    [
      32681
    ]
  ],
  "./es.json": [
    "69084",
    [
      73613
    ]
  ],
  "./no.json": [
    "21196",
    [
      83252
    ]
  ],
  "./cs.json": [
    "78786",
    [
      49759
    ]
  ],
  "./en.json": [
    "99595",
    [
      17112
    ]
  ],
  "./description/en.json": [
    "67320",
    [
      14849
    ]
  ],
  "./pl.json": [
    "35436",
    [
      7261
    ]
  ],
  "./hu.json": [
    "31071",
    [
      95124
    ]
  ],
  "./nl.json": [
    "11998",
    [
      26323
    ]
  ],
  "./de.json": [
    "48451",
    [
      95872
    ]
  ],
  "./pt.json": [
    "50100",
    [
      57877
    ]
  ],
  "./it.json": [
    "71561",
    [
      63826
    ]
  ],
  "./et.json": [
    "87389",
    [
      96494
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 81701;
module.exports = __rspack_async_context;
